import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import strings from 'localization/strings';
import queryString from 'query-string';
import { createMessage } from 'actions/messages';
import { handleResponse } from 'actions/actionHelpers';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import conversationCategories from 'enums/conversationCategories';

import Button from '@material-ui/core/Button';
import MessageDialog from 'components/MessageDialog';

const ContactOwner = ({ storageSite, userId, actorId, setIsSaving, onLogIn }) => {
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));
    const location = useLocation();
    const dispatch = useDispatch();

    const querystringParameters = queryString.parse(location.search);
    const [messageDialogOpen, setMessageDialogOpen] = useState(querystringParameters.messageDialogOpen || false);

    const handleMessageDialogOpen = () => {
        if(!actorId) {
            onLogIn({ messageDialogOpen: true }, strings.loginRequiredForContactOwnerBody);
        } else {
            setMessageDialogOpen(true);
        }
    };

    const handleMessageDialogOk = values => {
        const successContent = { dialog: { title: strings.postMessageSucceededTitle, body: strings.postMessageSucceededTenantBody } };
        const failureContent = { dialog: { title: strings.postMessageFailedTitle, body: strings.postMessageFailedBody } };

        const createMessageRequest = {
            senderUserId: userId,
            senderActorId: actorId,
            body: values.body,
            storageSiteId: storageSite.id,
            recipientActorId: storageSite.ownerActor.id,
            category: conversationCategories.general.key
        };

        setMessageDialogOpen(false);
        setIsSaving(true);
        dispatch(createMessage(createMessageRequest))
            .then(handleResponse(
                () => {
                    setIsSaving(false);
                    return successContent;
                },
                () => {
                    setIsSaving(false);
                    return failureContent;
                }
            ));
    };

    const handleMessageDialogClose = () => {
        setMessageDialogOpen(false);
    };

    return (
        <>
           <Button
                type="button"
                color="primary"
                variant="contained"
                fullWidth={isMobile}
                onClick={handleMessageDialogOpen}
            >
                {strings.contactTheOwner}
            </Button>
            <MessageDialog
                title={strings.contactTheOwner}
                content={strings.askAQuestionToOwnerNoBooking}
                conversationCategories={[conversationCategories.general]}
                open={messageDialogOpen}
                onOk={handleMessageDialogOk}
                onClose={handleMessageDialogClose}
            />
        </>
    );
};

ContactOwner.propTypes = {
    storageSite: PropTypes.object.isRequired,
    userId: PropTypes.number,
    actorId: PropTypes.number,
    setIsSaving: PropTypes.func,
    onLogIn: PropTypes.func.isRequired,
    messageDialogOpen: PropTypes.bool
};

export default ContactOwner;
